var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.03 12.081 3.03 3.03a1.429 1.429 0 0 0 2.021 0l3.03-3.03m-8.08 0a1.429 1.429 0 0 1 0-2.02l4.04-4.04m-4.04 6.06h8.08m0-2.02-3.03-3.03m3.03 3.03a1.429 1.429 0 0 1 0 2.02m0-2.02-4.04-4.04M8.05 4l2.02 2.02M5 20h14m-2.5-7.5c-.5.5-1.5 2.25-1.5 3s.75 1.5 1.5 1.5 1.5-.75 1.5-1.5-1-2.5-1.5-3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHighlight;